module.exports = {
	window : {
		resize : "resize"
	},
	app : {
		stateChange : "ev.app.statechange"
	},

	history : {
		other : "history.change.other",
		posts : "history.change.posts",
		index : "history.change.index"
	}
};


/** WEBPACK FOOTER **
 ** ./src/js/models/events.js
 **/